<template>
  <div class="c-land-middle">
    <Render :render="renderMap"></Render>
  </div>

</template>

<script>
import { Render } from '@CommonComponent';

export default {
    data () {
        return {

        };
    },
    components: {
        Render,
    },
    props: {
        renderMap: Function,
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';

@include b(land-middle, c) {
  width: 100%;
  height: 100%;

}
</style>
